export const isProdEnv = () =>
  location.host === "www.moodys.com" || location.host === "uw2.moodys.com";
